import { forwardRef, Ref, SVGProps } from 'react'

const Height = forwardRef((props: SVGProps<SVGSVGElement>, svgRef: Ref<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" ref={svgRef} {...props}>
    <path
      fill="currentColor"
      d="M6.8 8.5L12 3l5.3 5.5-1.1 1.2-3.4-3.5V18l3.4-3.5 1.1 1.1L12 21l-5.3-5.5 1.1-1.1 3.4 3.5V6.1L7.9 9.6 6.8 8.5z"
    />
  </svg>
))

Height.displayName = 'Height'

export default Height
